<style>
  .section-not-initialized {
    text-align: center;
    margin: 10px 0;
    padding: 30px 0;
    /*border: 1px dashed #dadada;*/
    color: #616161;

    display: flex;
    flex-direction: column;
    justify-content: center; align-items: center;
  }
</style>

<template>

  <div
    class="section-not-initialized"
  >
    <div style="font-size: 30px; display: none;">
      {{ translate(section.title) }}
    </div>
    <DialogResourceSuggestions :section="section"/>
  </div>

</template>

<script>
import Mixin from '@/mixins/mixin';
import DialogResourceSuggestions from '@/components/dialogs/DialogResourceSuggestions';

export default {
  name: 'TemplateSectionPlaceholder',
  components: { DialogResourceSuggestions },
  mixins: [Mixin],
  props: {
    section: Object,
  },
  data: () => ({}),
  computed: {},
  methods: {},
  mounted() {},
  updated() {},
};
</script>
